angular.module('app').config(paymentGatewaysRouting);

function paymentGatewaysRouting($routeProvider) {
  $routeProvider.when('/payment_gateways', {
    pageTitle: 'PAYMENT_GATEWAYS',
    template: '<payment-gateways-page></payment-gateways-page>',
    breadcrumb: {
      label: 'COMPANY_SETTINGS',
      parent: 'ng/company_settings',
    },
    menu: 'settings',
    accessPermission: 'show_company_both',
    authReq: true,
  });
}

paymentGatewaysRouting.$inject = ['$routeProvider'];
